/** Search params accepted by `/psymodeler`. Kept out of the zone chunk so the
 *  router can type them without pulling the editor in. */
export interface ModelerSearch {
  /**
   * Open the scheme bound to this cabinet situation instead of the scratch one.
   *
   * Тип — объединение, и это про АДРЕС, а не про модель. Роутер обязан уметь
   * вернуть строку такой же строкой, поэтому строку «52» он кодирует с
   * кавычками: `?situation="52"`. Кавычки видит человек в строке браузера и
   * копирует их в письмо. Поэтому разбор ниже оставляет число ЧИСЛОМ (и
   * строку из цифр делает числом), а к строке id приводит тот, кто его
   * читает (`String(search.situation)` в ModelerPage).
   */
  situation?: string | number
  /** Строка библиотеки напрямую — вход карточек кабинета. Объединение по той
   *  же причине, что и выше: число уезжает в адрес без кавычек. */
  scheme?: string | number
  /**
   * Одна из витринных схем (`features/showcase`) — вход с лэндинга: человек
   * досмотрел разбор и нажал «продолжить руками». Копия попадает в его
   * собственное хранилище, как любая чужая схема, и аккаунта не требует.
   */
  demo?: string
}

/**
 * Server ids travel as strings in memory but as bare digits in a URL, and the
 * router's default parser JSON-parses every search value — so `?situation=1`
 * arrives as the NUMBER 1. Rejecting it would drop the binding on reload or on
 * a shared link: the modeler would open an unbound scheme and then autosave it
 * into a fresh library row instead of the situation's.
 *
 * ЧИСЛО ОСТАЁТСЯ ЧИСЛОМ. Роутер записывает в адрес то, что вернула эта функция,
 * а строку «52» он обязан вернуть строкой — и кодирует её кавычками:
 * `?situation=%2252%22`. Прежняя версия приводила число к строке ЗДЕСЬ, и адрес
 * обрастал кавычками при каждом открытии редактора (находка агента-персоны:
 * такой адрес копируют в письмо). Теперь строка из одних цифр — в том числе
 * пришедшая из старого адреса с кавычками — становится числом, адрес
 * выпрямляется сам, а к строке id приводится в месте использования
 * (`ModelerPage`: `String(search.situation)`).
 */
const asId = (value: unknown): string | number | undefined => {
  if (typeof value === 'number' && Number.isFinite(value)) return value
  if (typeof value !== 'string' || value === '') return undefined
  return /^[1-9]\d{0,14}$/.test(value) ? Number(value) : value
}

export function parseModelerSearch(search: Record<string, unknown>): ModelerSearch {
  return {
    situation: asId(search.situation),
    scheme: asId(search.scheme),
    demo: typeof search.demo === 'string' && search.demo !== '' ? search.demo : undefined,
  }
}
